// SPDX-License-Identifier: MIT
// Graines de plafonds 5 h (en TOKENS facturables approximatifs). DETTE RECHERCHE
// (cf spec §6) : les chiffres publics Anthropic sont en MESSAGES et flous ; ces
// graines servent UNIQUEMENT de point de départ — le vrai plafond est appris au
// throttle réel (calibrateCapFromThrottle) et écrase la graine côté usage-store.
import type { PlanTier } from './usage-types';

// ~90 msg/5h Pro post-6-mai-2026 ; on convertit en tokens via un coût moyen/msg
// prudent (~12k tok facturables/msg). À RAFFINER quand la recherche §6 est faite.
const AVG_BILLABLE_PER_MSG = 12_000;
const PRO_MSGS = 90;
const SEED: Record<Exclude<PlanTier, 'unknown'>, number> = {
  pro: PRO_MSGS * AVG_BILLABLE_PER_MSG,
  max5: PRO_MSGS * 5 * AVG_BILLABLE_PER_MSG,
  max20: PRO_MSGS * 20 * AVG_BILLABLE_PER_MSG,
};

export function capTokensFor(tier: PlanTier): number | null {
  return tier === 'unknown' ? null : SEED[tier];
}

// Le volume réellement consommé quand rate_limit est passé throttled = vrai plafond.
export function calibrateCapFromThrottle(windowTokensAtThrottle: number): number {
  return windowTokensAtThrottle;
}

// "je ne sais pas" : choisir le palier dont la graine est la plus proche de l'observé.
export function inferTierFromObservedCap(observedCap: number): PlanTier {
  const tiers: Exclude<PlanTier, 'unknown'>[] = ['pro', 'max5', 'max20'];
  // tie → lower tier wins (conservative: never over-estimates headroom)
  return tiers.reduce((best, t) =>
    Math.abs(SEED[t] - observedCap) < Math.abs(SEED[best] - observedCap) ? t : best, tiers[0]);
}
